import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class LocalizeRouterService {
    private translateService = inject(TranslateService);

    translateRoute(url: string | string[] | null): string[] {
        if (url === null) {
            return ['.'];
        }

        let parts = typeof url === 'string' ? url.split('/') : [...url];

        if (parts[0].startsWith('/')) {
            parts = ['', ...parts];
        }

        parts = parts.map((part) => part.replace('/', ''));

        if (parts[0] === '') {
            parts.splice(1, 0, this.translateService.currentLang);
            parts[0] = '/';
        }

        parts = parts.map((part) => {
            const key = `ROUTES.${part}`;
            const translation = this.translateService.instant(`ROUTES.${part}`);
            if (translation === key) {
                return part;
            }
            return translation;
        });

        // Drop trailing empty segments so '/' resolves to ['/', '<lang>'] instead of
        // ['/', '<lang>', ''] — the latter builds the URL '/pl/', whose trailing slash
        // falls through the empty-path child and gets caught by the ** wildcard.
        while (parts.length > 1 && parts[parts.length - 1] === '') {
            parts.pop();
        }

        return parts;
    }
}
